import React from 'react';

/**
 * WHO CAN SEE THE TEAM WORKLOAD (migration 089, lib/settings.js
 * todoWorkloadAudience) - one rule on the Settings -> Rules page, kept to
 * itself so AppRules.js mounts it with one line.
 *
 * Two positions, a choice of one: administrators only (the default -
 * Gordon's decision: whose plate is how full is a management view until the
 * firm says otherwise), or every member of staff, who then sees the people
 * on the lists they are on and nothing beyond them. A contractor never sees
 * it under either; a to-do in somebody's Private list is in nobody's.
 *
 * Reads and writes exactly like the other rules: `rules` is GET
 * /app-settings, `setRule(key, path, value)` PUTs /app-settings/<path>.
 */
export const WORKLOAD_AUDIENCES = ['admins', 'staff_shared'];

export default function TodoWorkloadRule({ rules, canEdit, saving, setRule }) {
  // Administrators when absent or unrecognised, matching the server's default.
  const value = WORKLOAD_AUDIENCES.includes(rules?.todo_workload_audience) ? rules.todo_workload_audience : 'admins';
  return (
    <div className="ar-rule" data-rule="todo-workload-audience">
      <fieldset className="ar-choice ar-choice-first">
        <legend className="ar-label">Who can see the team workload</legend>
        {[
          ['admins', 'Administrators only'],
          ['staff_shared', 'Staff too — each sees the people on their shared lists']
        ].map(([v, label]) => (
          <label className="ar-check" key={v}>
            <input
              type="radio"
              name="todo-workload-audience"
              value={v}
              checked={value === v}
              disabled={!canEdit || saving === 'todo_workload_audience'}
              onChange={() => setRule('todo_workload_audience', 'todo-workload-audience', v)}
            />
            <span className="ar-label">{label}</span>
          </label>
        ))}
      </fieldset>
      <p className="ar-consequence">
        {value === 'admins'
          ? 'Administrators only: Assigned › Team on the to-do page, and the drag-to-hand-over '
            + 'that goes with it, are theirs alone. Everybody else sees Assigned › To me and By me.'
          : 'Staff too: a member of staff opens Assigned › Team and sees the people on the lists '
            + 'they are on — never a to-do on a list they are not on. Administrators see everybody.'}
        {' '}Contractors never see it, and nothing in anybody’s Private list is ever in it.
      </p>
    </div>
  );
}
